<template>
  <el-container>
    <el-header height="80px">
      <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" id="elMenu" @select="handleSelect" v-top-menu-scroll>
        <el-menu-item @click="back()">后退</el-menu-item>
        <el-menu-item index="/jiashaoIndex">首页</el-menu-item>
        <el-submenu :index="'/jiashao/gasclamp'">
          <template slot="title">全桥除湿数据</template>
          <el-menu-item index="/jiashao/gasclamp/towerStation"> 塔柱除湿机组除湿数据 </el-menu-item>
          <el-menu-item index="/jiashao/gasclamp/steelboxStation"> 钢箱梁除湿机组除湿数据 </el-menu-item>
          <el-menu-item index="/jiashao/power/towerStation"> 塔柱除湿机组能耗数据 </el-menu-item>
          <el-menu-item index="/jiashao/power/steelboxStation"> 钢箱梁除湿机组能耗数据 </el-menu-item>
        </el-submenu>
        <el-submenu :index="'/jiashao/towerStation'">
          <template slot="title">塔柱除湿机组</template>
          <el-menu-item index="/jiashao/towerStation/station2"> Z3上塔T1除湿机组(2#) </el-menu-item>
          <el-menu-item index="/jiashao/towerStation/station1"> Z3中塔T2除湿机组(1#) </el-menu-item>
          <el-menu-item index="/jiashao/towerStation/station5"> Z4上塔T3除湿机组(5#) </el-menu-item>
          <el-menu-item index="/jiashao/towerStation/station8"> Z4中塔T4除湿机组(8#) </el-menu-item>
          <el-menu-item index="/jiashao/towerStation/station12"> Z5上塔T5除湿机组(12#) </el-menu-item>
          <el-menu-item index="/jiashao/towerStation/station6"> Z5中塔T6除湿机组(6#) </el-menu-item>
          <el-menu-item index="/jiashao/towerStation/station7"> Z6上塔T7除湿机组(7#) </el-menu-item>
          <el-menu-item index="/jiashao/towerStation/station16"> Z6中塔T8除湿机组(16#) </el-menu-item>
          <el-menu-item index="/jiashao/towerStation/station3"> Z7上塔T9除湿机组(3#) </el-menu-item>
          <el-menu-item index="/jiashao/towerStation/station10"> Z7中塔T10除湿机组(10#) </el-menu-item>
          <el-menu-item index="/jiashao/towerStation/station4"> Z8上塔T11除湿机组(4#) </el-menu-item>
          <el-menu-item index="/jiashao/towerStation/station29"> Z8中塔T12除湿机组(29#) </el-menu-item>
        </el-submenu>
        <el-submenu :index="'/jiashao/steelboxStation'">
          <template slot="title">钢箱梁除湿机组</template>
          <el-menu-item index="/jiashao/steelboxStation/station19"> Z3B5-L钢箱梁G1除湿机组(19#) </el-menu-item>
          <el-menu-item index="/jiashao/steelboxStation/station17"> Z3B5-R钢箱梁G2除湿机组(17#) </el-menu-item>
          <el-menu-item index="/jiashao/steelboxStation/station20"> Z4B11-L钢箱梁G3除湿机组(20#) </el-menu-item>
          <el-menu-item index="/jiashao/steelboxStation/station18"> Z4B11-R钢箱梁G4除湿机组(18#) </el-menu-item>
          <el-menu-item index="/jiashao/steelboxStation/station21"> Z4Z8-R钢箱梁G5除湿机组(21#) </el-menu-item>
          <el-menu-item index="/jiashao/steelboxStation/station13"> Z4Z8-L钢箱梁G6除湿机组(13#) </el-menu-item>
          <el-menu-item index="/jiashao/steelboxStation/station15"> Z5Z1-R钢箱梁G7除湿机组(15#) </el-menu-item>
          <el-menu-item index="/jiashao/steelboxStation/station9"> Z5Z1-L钢箱梁G8除湿机组(9#) </el-menu-item>
          <el-menu-item index="/jiashao/steelboxStation/station31"> Z6Z1-L钢箱梁G9除湿机组(31#) </el-menu-item>
          <el-menu-item index="/jiashao/steelboxStation/station26"> Z6Z1-R钢箱梁G10除湿机组(26#) </el-menu-item>
          <el-menu-item index="/jiashao/steelboxStation/station30"> Z7Z8-L钢箱梁G11除湿机组(30#) </el-menu-item>
          <el-menu-item index="/jiashao/steelboxStation/station25"> Z7Z8-R钢箱梁G12除湿机组(25#) </el-menu-item>
          <el-menu-item index="/jiashao/steelboxStation/station11"> Z7B11-R钢箱梁G13除湿机组(11#) </el-menu-item>
          <el-menu-item index="/jiashao/steelboxStation/station32"> Z7B11-L钢箱梁G14除湿机组(32#) </el-menu-item>
          <el-menu-item index="/jiashao/steelboxStation/station28"> Z8B5-R钢箱梁G15除湿机组(28#) </el-menu-item>
          <el-menu-item index="/jiashao/steelboxStation/station14"> Z8B5-L钢箱梁G16除湿机组(14#) </el-menu-item>
        </el-submenu>
        <el-submenu :index="'/jiashao/rigidHingeStation'">
          <template slot="title">刚性铰除湿机组</template>
          <el-menu-item index="/jiashao/rigidHingeStation/station27"> J3-R刚性铰J1除湿机组(27#) </el-menu-item>
          <el-menu-item index="/jiashao/rigidHingeStation/station22"> J3-R刚性铰J2除湿机组(22#) </el-menu-item>
          <el-menu-item index="/jiashao/rigidHingeStation/station24"> J3-L刚性铰J3除湿机组(24#) </el-menu-item>
          <el-menu-item index="/jiashao/rigidHingeStation/station23"> J3-L刚性铰J4除湿机组(23#) </el-menu-item>
        </el-submenu>
        <el-menu-item index="/jiashao/errorRecord?bridgeId=3b04991c-3662-4948-930e-ac537ed82fd3">报警记录</el-menu-item>
        <el-submenu :index="'/jiashao/currentHumidityList?bridgeId=3b04991c-3662-4948-930e-ac537ed82fd3'">
          <template slot="title">湿度数据清单</template>
          <el-menu-item index="/jiashao/currentHumidityList?bridgeId=3b04991c-3662-4948-930e-ac537ed82fd3&includePower=true"
            >湿度数据清单</el-menu-item
          >
          <el-menu-item index="/jiashao/currentDataTable?bridgeId=3b04991c-3662-4948-930e-ac537ed82fd3">实时数据表</el-menu-item>
          <el-menu-item index="/jiashao/dataSourceConnection">数据源连接状态</el-menu-item>
        </el-submenu>
        <el-submenu :index="'/jiashao/dataHistory?bridgeId=3b04991c-3662-4948-930e-ac537ed82fd3&scenarioId=TBD'">
          <template slot="title">数据历史</template>
          <el-menu-item index="/jiashao/dataHistory?bridgeId=3b04991c-3662-4948-930e-ac537ed82fd3&scenarioId=TBD"> 查询数据历史 </el-menu-item>
          <el-menu-item index="/jiashao/dataHistory?bridgeId=3b04991c-3662-4948-930e-ac537ed82fd3"> 自定义数据历史 </el-menu-item>
        </el-submenu>
      </el-menu>
      <HeaderTime bridgeName="JIASHAO" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
    </el-header>
    <el-main class="el-main jiashao">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
import topMenuScroll from '../../tools/TopMenuScroll.js'

export default {
  name: "jiashao",
  data() {
    return {
      bridgeId: "3b04991c-3662-4948-930e-ac537ed82fd3",
      envInfo: {
        envId: "86c286d3-da48-444b-ad49-bb3603888069",
        weather: "f8bee0f1-31e3-4c50-8951-dc4f88c6cfd1",
        humidity: "fd923db1-c8ff-4603-a0d9-21529de7b79f",
        temperature: "bd007a59-c7ea-4f27-92c4-3d2a8b79076b",
        weatherAbsoluteHumidity: "08de8391-4bd3-47e9-a7ec-2374502e36b5",
      },
      id2Path: {},
      activeIndex: "",
      historyScenarioList: [],
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: "getIsAdmin",
    }),
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

    document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;
    },
  },
  directives: {
    topMenuScroll,
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;
  display: none;
}
</style>
